/**
 * @file index.js
 * @author Fernando Ruano
 * @description Initialize PatientRecords View .
 */

// Commons
import {
  mapStateToProps,
  mapDispatchToProps
} from '@nephro/commons/mapReduxCRUD/index';

// Dependencies
import { connect } from 'react-redux';

// View
import View from './patientRecordsView';

export const mapStateToPropsPatientRecordsView = mapStateToProps;
export const mapDispatchToPropsPatientRecordsView = mapDispatchToProps;

export default connect(
  mapStateToPropsPatientRecordsView,
  mapDispatchToPropsPatientRecordsView
)(View);
